<template>
  <div class="peoplelist" @scroll="onScrolls()" ref="people">
    <!-- 新增人员 （签到人） -->
    <div class="people-item" v-if="canAdd" @click="onAdd">
      <div class="add-person">+</div>
      <div class="add-name">补签</div>
    </div>
    <!-- 人员列表 -->
    <div v-for="(item,index) in arr" class="people-item" :key="item.id">
      <!-- 头像 -->
      <div class="headpicture-wrapper">
        <img class="headpicture" v-lazy="item.headPicUrl || require('@/assets/images/default.png')">
        <div class="iconfont icon-delete" v-if="item.canDelete" @click="openDeleteModal(true,index)"></div>
      </div>
      <!-- 昵称 -->
      <div class="username">{{item.userName}}</div>
      <Modal v-model="isShowDelete" title="删除" width="660px" @on-ok="onDelete" @on-cancel="openDeleteModal(false)">
        <div>确定删除本条记录吗？</div>
      </Modal>
    </div>

  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  props: {
    arr: {
      // 人员列表
      type: Array,
      default: []
    },
    canAdd: {
      // 是否可以新增
      type: Boolean,
      default: false
    },
    loadFinish: Boolean, // 数据加载接口请求完成
    loadComplete: Boolean, // 加载完成

  },
  data() {
    //这里存放数据
    return {
      isShowDelete:false,
      delIndex:''
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 页面滚动到底部加载 默认触底高度200
    onScrolls(distance = 200) {
      if (!this.loadComplete && this.loadFinish) {
        let that = this;
        let { offsetHeight, scrollHeight, scrollTop } = that.$refs.people;
        let scrollBottom = offsetHeight + scrollTop;
        if (scrollBottom >= scrollHeight - distance) {
          console.log("滚动++++++++++++++++++++++++++++++滚动");
          that.$emit("scrollPeople");
        }
      }
    },
    /* 删除操作 */
    onDelete() {
      this.$emit("onDelete", this.delIndex);
    },
    /* 添加签到人 */
    onAdd() {
      this.$emit("onAdd");
    },
    openDeleteModal(val,index){
      if (val) this.delIndex = index
      this.isShowDelete = val
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {

  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
.peoplelist {
  display: grid;
  grid-template-columns: 100px 100px; // 两列 各100px
  justify-content: center; // 水平方向均分剩余空间 居中对齐
  align-content: start; // 垂直方向
  justify-items: center; // 内容相遇于网格 水平方向居中对齐
  align-items: start; // 内容相对于网格 垂直方向居中
  grid-row-gap: 20px; // 网格 各行之间的缝隙
  grid-column-gap: 10px; // 网格列 间距
  overflow-y: scroll;
  overflow-x: hidden;

  // ie 10 11 12
  -ms-scroll-chaining: chained;
  -ms-overflow-style: none;
  -ms-content-zooming: zoom;
  -ms-scroll-rails: none;
  -ms-content-zoom-limit-min: 100%;
  -ms-content-zoom-limit-max: 500%;
  -ms-scroll-snap-type: proximity;
  -ms-scroll-snap-points-x: snapList(100%, 200%, 300%, 400%, 500%);
  -ms-overflow-style: none;
}
.peoplelist::-webkit-scrollbar {
  width: 0;
}
.people-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}
/* 头像以及事件 */
.radiusPic {
  height: 60px;
  width: 60px;
  border-radius: 50%;
}
.headpicture-wrapper {
  position: relative;
  margin-bottom: 10px;
  .radiusPic;
  .icon-delete {
    .radiusPic;
    position: absolute;
    top: 0;
    left: 0;
    z-index: -1;

    display: flex;
    justify-content: center;
    align-items: center;

    font-size: 25px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    cursor: pointer;
    opacity: 0;
    transition: all 300ms cubic-bezier(0.075, 0.82, 0.165, 1);
  }
  &:hover .icon-delete {
    z-index: 1;
    opacity: 1;
  }
}
.headpicture {
  .radiusPic;
  border: 1px solid #ddd;
}
// 添加人员
.add-person {
  .radiusPic;
  line-height: 55px;
  text-align: center;
  color: #5c6e94;
  font-size: 30px;
  font-weight: 600;
  border: 1px solid #5c6e94;
  margin-bottom: 10px;
  cursor: pointer;
}
.add-name {
  color: #5c6e94;
  font-size: 14px;
}
.name {
  color: #444;
  font-size: 18px;
}
.item {
  border: 1px solid #333;
  border-radius: 12px;
  height: 24px;
  line-height: 24px;
  padding: 0 16px;
  font-size: 12px;
}
.time {
  color: #999;
  font-size: 12px;
  text-align: right;
}
</style>
